import type { ModuleTagEntry } from './index';

/** Clinical Trial module tags. */
export const tags: ModuleTagEntry[] = [
  'ClinicalTrialSponsorName',
  'ClinicalTrialSiteID',
  'ClinicalTrialSiteName',
  'ClinicalTrialSubjectID',
];
